import styled from 'styled-components';

export const StyledActivitiesStats = styled.div`
  counter-reset: activity-n;

  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 100%;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.bgBox};
  margin: -16px 0 16px;

  &:empty::before {
    content: 'Nessuna attività disponibile';
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: 100%;

  hr {
    margin-top: 8px;
  }
`;
